import { useCatalogActionsContext } from "@components/Actions/CatalogActions/CatalogActionsContext";
import ModalToOpenService from "@core-ui/ContextServices/ModalToOpenService/ModalToOpenService";
import ModalToOpen from "@core-ui/ContextServices/ModalToOpenService/model/ModalsToOpen";
import RepositoryPermissionTrigger from "@ext/enterprise/components/RepositoryPermission/RepositoryPermission";
import type GesCloudRepositoryPermission from "@ext/enterprise-cloud/components/Catalog/GesCloudRepositoryPermission";
import { type ComponentProps, type ReactNode, useCallback } from "react";

interface GesCloudRepositoryPermissionItemProps {
	children?: ReactNode;
}

const GesCloudRepositoryPermissionItem = ({ children }: GesCloudRepositoryPermissionItemProps) => {
	const { catalogName, sourceName, pathName } = useCatalogActionsContext();

	const onClick = useCallback(() => {
		ModalToOpenService.setValue<ComponentProps<typeof GesCloudRepositoryPermission>>(
			ModalToOpen.GesCloudRepositoryPermission,
			{
				pathName,
				catalogName,
				sourceName,
				onClose: () => ModalToOpenService.resetValue(),
			},
		);
	}, [pathName, catalogName, sourceName]);

	return <RepositoryPermissionTrigger onClick={onClick}>{children}</RepositoryPermissionTrigger>;
};

export default GesCloudRepositoryPermissionItem;
